export default __webpack_public_path__ + "static/media/progressbar_5.39b06e69.PNG";